<template>
  <div class="row">
    <div class="col-md-6 user-password-profile">
      <div class="title">НЭВТРЭХ НУУЦ ҮГ СОЛИХ</div>
      <form
        action=""
        class="user-edit-panel-profile"
        @submit.prevent="changePassword"
      >
        <div class="form-group">
          <label for="">ХУУЧИН НУУЦ ҮГ:* </label>
          <div class="user-input">
            <input type="password" class="form-control" v-model="oPassword" />
          </div>
        </div>
        <div class="form-group">
          <label for="">ШИНЭ НУУЦ ҮГ:* </label>
          <div class="user-input">
            <input type="password" class="form-control" v-model="nPassword" />
          </div>
        </div>
        <div class="form-group">
          <label for="">ШИНЭ НУУЦ ҮГ ДАВТАХ:* </label>
          <div class="user-input">
            <input type="password" class="form-control" v-model="rPassword" />
          </div>
        </div>
        <div class="form-group">
          <label for=""> </label>
          <div class="user-input">
            <input type="submit" class="btn user-btn" value="Хадгалах" />
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-6">
      <div class="reset-password-error">
        <div class="reset-password-error-inner" v-if="errorBox">
          <div class="password-error-icon">
            <img src="@/assets/icon/danger.png" alt="" />
          </div>
          <div class="password-error-msg">
            {{ errorBoxMessage }}
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
      ></Success>
    </transition>
  </div>
</template>

<script>
import Error from "@/views/plugin/error";
import Success from "@/views/plugin/success";
import EventBus from "@/EventBus.js";
export default {
  data() {
    return {
      oPassword: "",
      nPassword: "",
      rPassword: "",
      errorBox: false,
      errorBoxMessage: "",
      errorMessage: "",
      successMessage: "",
      errorModal: false,
      successModal: false,
    };
  },
  methods: {
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    changePassword() {
      var newPassword = this.nPassword;
      var rPassword = this.rPassword;
      var oldPassword = this.oPassword;
      if (newPassword.length >= 8) {
        if (newPassword === rPassword) {
          //lowercase,uppercase,digits,special digits
          let isCheckPassword =
            /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,25}$/.test(
              newPassword
            );
          if (isCheckPassword) {
            var tokenId = localStorage.getItem("authToken");
            var user = this.$auth.getMe();
            if (tokenId == null || user == null) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
            var cardHolderInfId = user.cardHolderInfId;
            this.$axiosApi
              .post(`system/forgotpassword/changepassword`, {
                tokenId,
                cardHolderInfId,
                oldPassword,
                newPassword,
              })
              .then((response) => {
                if (response.data.status === 0) {
                  this.oPassword = "";
                  this.nPassword = "";
                  this.rPassword = "";
                  this.successMessage = "Нэвтрэх нууц үг амжилттай солилоо";
                  this.successModal = true;
                } else if (response.data.status === 100) {
                  this.errorBoxMessage = " ";
                  this.errorBox = false;
                  this.errorMessage = response.data.message;
                  this.errorModal = true;
                  this.$insProgress.finish();
                }
              })
              .catch((error) => {
                this.RedirectLogin();
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: "login" });
              });
          } else {
            this.errorBoxMessage =
              "Таны оруулсан нууц үг том, жижиг үсэг, тоо, тусгай тэмдэгт /!@#$%^&*/ агуулсан байна!";
            this.errorBox = true;
          }
        } else {
          this.errorBoxMessage =
            "Таны оруулсан нууц үг хоорондоо ижил биш байна.";
          this.errorBox = true;
        }
      } else {
        this.errorBoxMessage =
          "Та хамгийн багадаа 8 оронтой нууц үг оруулна уу.";
        this.errorBox = true;
      }
    },
  },
  components: {
    Error,
    Success,
  },
  created() {
    this.errorBoxMessage = "";
    this.errorBox = false;
  },
};
</script>

<style>
.user-password-profile {
  margin-top: 50px;
  padding-right: 3.5% !important;
}
.user-password-profile .title {
  font-size: 16px;
  width: 100%;
  color: #1660ab;
  font-weight: 500;
  text-align: right;
}
.user-password-profile .form-group .user-input {
  flex: 1 !important;
  justify-content: flex-end !important;
}
.user-password-profile .form-group .user-input input {
  width: 100% !important;
}
.user-password-profile .user-btn {
  height: 45px !important;
  border-radius: 5px !important;
  background-color: #1660ab !important;
  text-align: center !important;
  color: #ffffff;
  font-size: 13px;
}
.reset-password-error {
  margin-top: 110px;
}
.reset-password-error-inner {
  width: 280px;
  height: 120px;
  border-radius: 5px;
  background-color: #fffafa;
  border: 1px solid #fad4ab;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding-top: 21px;
  padding-right: 30px;
  padding-bottom: 22px;
}
.reset-password-error-inner .password-error-icon {
  flex: 1;
  padding-left: 20px;
  color: #ed3237;
}
.reset-password-error-inner .password-error-msg {
  flex: 5;
  font-size: 11px;
  font-weight: 300;
  color: #000000;
}
.user-password-profile .form-group .user-input {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  border-radius: 2px;
}
.user-password-profile .form-group .user-input input {
  height: 30px;
  width: 100%;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.05);
}
</style>
